import React, { useState, useEffect, useRef, forwardRef } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Popconfirm,
  message,
  Modal,
  Card,
  Tooltip,
  DatePicker,
  Select,
  Rate,
  Badge,
  Tag,
} from "antd";

import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";

import { API_LIST_ORDER, API_DELETE_ORDER } from "api/order-management";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { CONSTANTS } from "config/constant";
import Invoice from "./Invoice"; // Assuming Invoice component file location
import ViewPlan from "views/admin/planesManagement/ViewPlan/ViewPlan";
import EditPlan from "views/admin/planesManagement/EditPlan";
import { useSelector } from "react-redux";
import cash from "../../../assets/img/orders/payment.png";
import COD from "../../../assets/img/orders/cashondelivery.png";
import CreditCard from "../../../assets/img/orders/credit-card.png";
import CashOnDelivery from "../../../assets/img/orders/cash-on-delivery.png";

import Printinvoice from "views/admin/orderManagement/ViewOrder/Printinvoice";
import { icons } from "antd/es/image/PreviewGroup";
import { Typography } from "antd";
import { API_GET_ORDER_OF_DRIVER } from "api/laundry-management";

const { Column } = Table;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select;
const DriverOrder = ({ id }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 });
  const [searchName, setSearchName] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [status, setStatus] = useState(null);
  const [orderType, setOrderType] = useState(null);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const componentRef = useRef();
  const { Text } = Typography;

  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  const options = [
    t("order_placed"),
    t("order_delivered_to_store_before_service"),
    t("order_delivered_to_laundry_before_service"),
    t("order_service_completed"),
    t("order_delivered_to_store_after_service"),
    t("order_delivered_successfully"),
  ];
  const formattedOptions = options?.map((status) => ({
    value: status,
    label: status
      ?.replace(/_/g, " ")
      ?.replace(/\b\w/g, (char) => char.toUpperCase()),
  }));
  // Fetch data from API
  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        order_user_name: searchName,
        order_status: status,
        order_type: orderType,
        minDate: startDate ? startDate.unix() : undefined,
        maxDate: endDate ? endDate.unix() : undefined,
      };
      const newData = await API_GET_ORDER_OF_DRIVER(params, id);
      setData(newData.orders); // Assuming newData structure
      setLoading(false);
      setPagination({ ...pagination, total: newData.total_orders });
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    pagination.current,
    pagination.pageSize,
    searchName,
    startDate,
    endDate,
    orderType,
    status,
  ]);
  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };
  const handleEdit = (record) => {
    setSelectedStore(record);
    setEditModalVisible(true);
    navigate(`/admin/order-management/edit/${record._id}`, {
      state: { data: record },
    });
  };
  const handleView = (record) => {
    setSelectedStore(record);
    setViewModalVisible(true);
    navigate(`/admin/order-management/${record._id}`, {
      state: { data: record },
    });
  };
  const handleDelete = async (id) => {
    try {
      const response = await API_DELETE_ORDER(id);
      message.success(response.message);
      fetchData();
    } catch (error) {
      console.error("Error deleting order:", error);
      message.error("Failed to delete order");
    }
  };
  const handleEditModalOk = () => {
    console.log("Editing order:", selectedStore);
    setEditModalVisible(false);
    fetchData();
  };

  const handleViewModalOk = () => {
    console.log("Viewing order:", selectedStore);
    setViewModalVisible(false);
  };

  const handleModalCancel = () => {
    setEditModalVisible(false);
    setViewModalVisible(false);
  };

  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const superAdminInfo = {
    logoUrl:
      CONSTANTS?.IMG_DIRECTORY + userData?.data?.profile_image?.[0]?.file_url,
    contact: {
      name: "SuperAdmin Name",
      email: "admin@example.com",
      phone: "+1234567890",
    },
  };

  console.log(data, "orderTableDataa");
  return (
    <div>
      <div className="mb-4 flex flex-wrap justify-between gap-4">
        <div className="w-full flex-grow sm:w-auto">
          <Input
            className="w-full border-none"
            placeholder={t("Search by name")}
            prefix={<SearchOutlined />}
            allowClear
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>

        <div className="w-full flex-grow sm:w-auto">
          <RangePicker
          placeholder={[t("Start Date"), t("End Date")]}
            onChange={(dates) => {
              setStartDate(dates ? dates[0] : null);
              setEndDate(dates ? dates[1] : null);
            }}
            className="w-full"
          />
        </div>

        <div className="w-full flex-grow sm:w-auto">
          <Select
            className="w-full border-none"
            onChange={(value) => setStatus(value)}
            value={status}
            placeholder={t("please pick order status")}
            options={formattedOptions}
            allowClear
          />
        </div>

        <div className="w-full flex-grow sm:w-auto">
          <Select
            placeholder={t("please pick order type")}
            value={orderType}
            onChange={(value) => setOrderType(value)}
            className="w-full"
            allowClear
          >
            <Option value="normal">{t("Normal")}</Option>
            <Option value="express">{t("Express")}</Option>
            <Option value="box">{t("Laundry Box")}</Option>
          </Select>
        </div>

        {/* <div className="flex w-full flex-grow justify-end sm:w-auto">
          <Link
            to={"/admin/order-management/create-order"}
            className="linear p-[4px 11px] flex w-full max-w-[9rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white hover:text-brand-500 dark:bg-brand-400 dark:text-white  dark:active:bg-brand-200"
          >
            + {t("Create order")}
          </Link>
        </div> */}
      </div>

      {/* </div> */}
      <Table
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey={(record) => record._id}
        rowClassName={getRowClassName}
        scroll={{ x: true }}
      >
        {/* Columns definition */}

        <Column
          title={t("Order ID")}
          dataIndex="order_id"
          key="order_id"
          width={"9rem"}
        />
        <Column
          title={t("Customer Name")}
          dataIndex="customer_name"
          key="customer_name"
          width={"9rem"}
          render={(text, record) => record.order_user_info?.first_name ?? "---"}
        />
        <Column
          title={t("Pick up Time")}
          dataIndex="order_pickup_time"
          key="order_pickup_time"
          width={"9rem"}
          render={(text, record) => {
            const formatTime = (unixTime) =>
              moment.unix(unixTime).format("DD MMMM YYYY, HH:mm:ss");

            const fromTime = record.order_pickup_time?.from;
            const toTime = record.order_pickup_time?.to;

            if (fromTime && toTime) {
              return (
                <>
                  {/* <Text>{`From: ${formatTime(fromTime)}`}</Text> */}
                  <Text className="flex h-[2px] gap-2">
                    From: <p>{formatTime(fromTime)}</p>
                  </Text>
                  <br />
                  <Text className="flex gap-2 ">
                    To: <p className="pl-4">{formatTime(toTime)}</p>
                  </Text>
                </>
              );
            }
            return "";
          }}
          // render={(text, record) => {
          //   return (
          //     moment
          //       .unix(record.order_pickup_time?.from)
          //       .format("DD MMMM YYYY") +
          //     "-" +
          //     moment
          //       .unix(record.order_pickup_time?.to)
          //       .format("DD MMMM YYYY")
          //   );

          //   // record.order_pickup_time?.from === record.order_pickup_time?.to ? moment
          //   // .unix(record.order_pickup_time?.from)
          //   // .format("DD/MM/YYYY HH:mm:ss") :  moment
          //   // .unix(record.order_pickup_time?.from)
          //   // .format("DD/MM/YYYY HH:mm:ss") + '-' + moment
          //   // .unix(record.order_pickup_time?.to)
          //   // .format("DD/MM/YYYY HH:mm:ss")
          // }}
        />

        <Column
          title={t("Delivery Time")}
          dataIndex="order_delivery_time"
          key="order_delivery_time"
          width={"9rem"}
          render={(text, record) => {
            const formatTime = (unixTime) =>
              moment.unix(unixTime).format("DD MMMM YYYY, HH:mm:ss");

            const fromTime = record?.order_delivery_time?.from;
            const toTime = record?.order_delivery_time?.to;

            if (fromTime && toTime) {
              return (
                <>
                  {/* <Text>{`From: ${formatTime(fromTime)}`}</Text> */}
                  <Text className="flex h-[2px] gap-2">
                    From: <p>{formatTime(fromTime)}</p>
                  </Text>
                  <br />
                  <Text className="flex gap-2">
                    To: <p className="pl-4">{formatTime(toTime)}</p>
                  </Text>
                </>
              );
            }

            return "";
          }}
        />

        {/* <Column
          title={t("Pick up Address")}
          dataIndex="order_pickup_address"
          key="order_pickup_address"
          width={"9rem"}
          render={(text, record) => (
            <Tooltip
              title={
                record.order_pickup_address?.location
                  ? record.order_pickup_address?.location
                  : record.order_pickup_address?.location
              }
            >
              {record.order_pickup_address?.location
                ? record.order_pickup_address?.location?.length > 20
                  ? `${record.order_pickup_address?.location?.substring(
                      0,
                      20
                    )}...`
                  : record?.order_pickup_address?.location
                : record?.order_pickup_address?.location
                ? record?.order_pickup_address?.location?.length > 20
                  ? `${record?.order_pickup_address?.location?.substring(
                      0,
                      20
                    )}...`
                  : record?.order_pickup_address?.location
                : "---"}
            </Tooltip>
          )}
        />
        <Column
          title={t("Delivery Address")}
          dataIndex="order_delivery_address"
          key="order_delivery_address"
          width={"9rem"}
          // render={(text, record) =>
          //   record.order_delivery_address?.additional_directions ?? "---"
          // }
          render={(text, record) => (
            <Tooltip title={record?.order_delivery_address?.location}>
              {record?.order_delivery_address?.location
                ? record?.order_delivery_address?.location?.length > 20
                  ? `${record?.order_delivery_address?.location?.substring(
                      0,
                      20
                    )}...`
                  : record?.order_delivery_address?.location
                : "--"}
            </Tooltip>
          )}
        /> */}
        <Column
          title={t("Order Status")}
          dataIndex="order_status"
          key="order_status"
          width={"9rem"}
          render={(text, record) => (
            <span>{record?.order_status?.replace(/_/g, " ")}</span>
          )}
        />

        <Column
          title={t("Order Type")}
          dataIndex="order_type"
          key="order_type"
          width={"9rem"}
        />

        <Column
          title={t("Payment Type")}
          dataIndex="payment_type"
          key="payment_type"
          width={"9rem"}
          render={(text, record) => (
            <>
              {" "}
              {record.invoice_details?.payment_type?.trim() ===
              "credit_card" ? (
                <div className="flex flex-row items-center gap-1">
                  Credit Card
                  {/* <img src = {CreditCard} alt = '' className="w-[25px] h-[25px]"/> */}
                </div>
              ) : record.invoice_details?.payment_type?.trim() ===
                "hand_cash" ? (
                <div className="flex flex-row items-center gap-3">
                  Hand Cash
                  {/* <img src = {cash} alt = '' className="w-[30px] h-[30px]"/> */}
                </div>
              ) : record.invoice_details?.payment_type?.trim() ===
                  "cash_on_delivery" ||
                record.invoice_details?.payment_type?.trim() === "cod" ? (
                <div className="flex flex-row items-center gap-1">
                  Cash on delivery
                  {/* <img src = {CashOnDelivery} alt = '' className="w-[25px] h-[25px]"/> */}
                </div>
              ) : record.invoice_details?.payment_type?.trim() ===
                "Pay by wallet" ? (
                <>Pay by wallet</>
              ) : record.invoice_details?.payment_type?.trim() === "wallet" ? (
                <>wallet</>
              ) : (
                "---"
              )}
            </>
          )}
        />

        {/*<Column
          title={t("Delivery Fee")}
          dataIndex="delivery_fee"
          key="delivery_fee"
          width={"9rem"}
          render={(text, record) =>
            record?.invoice_details?.delivery_fee
              ? `${record?.currency} ${record?.invoice_details?.delivery_fee}`
              : "---"
          }
        /> */}

        <Column
          title={t("Total Amount")}
          dataIndex="total"
          key="total"
          width={"9rem"}
          render={(text, record) => (
            <Tag color="red">
              {record?.currency}{" "}
              {Number(record?.invoice_details?.total_amount)?.toFixed(2) ?? 0}
            </Tag>
          )}
          // render={(text, record) =>
          //   record?.invoice_details?.total_amount ? (
          //     <Tag color="red">
          //       {record?.currency} {record?.invoice_details?.total_amount ?? 0}
          //     </Tag>
          //   ) : (
          //     "---"
          //   )
          // }
        />

        <Column
          title={t("Actions")}
          key="actions"
          width={"9rem"}
          render={(text, record) => (
            <Space>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />
              <Popconfirm
                title="Are you sure to delete this Order?"
                onConfirm={() => handleDelete(record._id)}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="danger"
                  icon={<DeleteOutlined />}
                  style={{ border: "1px solid #d9d9d9" }}
                />
              </Popconfirm>
              <Button
                type="default"
                icon={<EyeOutlined />}
                onClick={() => handleView(record)}
              />
              {/* <Button
                onClick={() => {
                  setSelectedOrder(record);
                  console.log("record", record);
                  setTimeout(() => {
                    handlePrint();
                  }, 100);
                }}
              >
                Print
              </Button> */}
            </Space>
          )}
        />
      </Table>

      <div style={{ display: "none" }}>
        <div
          className="flex flex-col items-center justify-center rounded-lg bg-white p-4 shadow-md "
          ref={componentRef}
        >
          <Printinvoice data={selectedOrder} />
        </div>
      </div>
      <Modal
        open={isModalOpen}
        // closable={true}
        closeIcon={false}
        onCancel={() => setIsModalOpen(false)}
        style={{ width: "674px", padding: "0px !important" }}
        className="w-[674px]"
      >
        <div className="flex w-[674px] justify-between gap-[28px] border-y-[1px] py-[18px]">
          <div
            style={{
              width: "299px",
              padding: "14px",
              boxShadow: "0px 0px 10px rgba(90, 176, 255, 0.25)",
            }}
            className="flex flex-col gap-[20px] shadow-xl shadow-[#5AB0FF40]"
          >
            <div className="flex flex-row justify-between gap-[58px]">
              <div className="flex flex-row gap-[12px]">
                <div className="h-[58.02px] w-[55px] rounded-[10px] bg-[#172E550D]"></div>
                <div className="flex flex-col gap-[15px]">
                  <p className="">T-Shirt</p>
                  <div></div>
                </div>
              </div>
            </div>
            <div></div>
          </div>
          <div
            style={{
              width: "299px",
              padding: "14px",
              boxShadow: "0px 0px 10px rgba(90, 176, 255, 0.25)",
            }}
            className="shadow-xl "
          >
            mext
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DriverOrder;
